import jss from 'jss';
import preset from 'jss-preset-default';
import $ from "jquery";
import "slick-carousel";
import { generateVectorPosition } from 'Client/utils/vector-position'
let widthDevice = window.innerWidth;
class WidgetReviewsOfOurBooks extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                slides: '#ecf-reviews-of-our-books .slides'
            },
        };
    }
    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $slides: this.$element.find(selectors.slides)
        };
    }
    bindEvents() {

    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetReviewsOfOurBooks, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction('frontend/element_ready/ecf_reviews_of_our_books.default', addHandler);
});